<template>
  <div class="form-steps">
    <template v-for="(step, index) in steps">
      <div
        :key="'step-' + index"
        class="form-step"
        :class="{ active: index + 1 === current, done: index + 1 < current }"
      >
        <div class="form-step-circle">
          <svg v-if="index + 1 < current" width="22" height="22" viewBox="0 0 24 24">
            <path fill="white" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/>
          </svg>
          <span v-else>{{ index + 1 }}</span>
        </div>
        <p>{{ step }}</p>
      </div>
      <div
        v-if="index < steps.length - 1"
        :key="'line-' + index"
        class="form-step-line"
        :class="{ done: index + 1 < current }"
      ></div>
    </template>
  </div>
</template>

<script>
export default {
  name: "FormSteps",

  props: {
    // Currently active step, steps below are shown as completed.
    // Pass steps.length + 1 to show every step as completed.
    current: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    steps: ["Formular ausfüllen", "E-Mail bestätigen", "Fertig"],
  }),
};
</script>
<style lang="scss">
.form-steps {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.form-step {
  text-align: center;
  min-width: 90px;

  p {
    margin: 8px 0px 0px 0px;
    color: var(--secondaryfont-color);
  }

  &.active,
  &.done {
    .form-step-circle {
      background-color: var(--msag-color);
      border-color: var(--msag-color);
      color: white;
    }
  }

  &.active p {
    color: var(--font-color);
    font-weight: bold;
  }
}

.form-step-circle {
  width: 40px;
  height: 40px;
  margin: 0 auto;
  border-radius: 50%;
  background-color: white;
  border: 2px solid #d5d5d5;
  color: var(--secondaryfont-color);
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-step-line {
  flex: 1;
  max-width: 110px;
  height: 2px;
  background-color: #d5d5d5;
  margin-top: 19px; // Vertically centers on the circles

  &.done {
    background-color: var(--msag-color);
  }
}
</style>
